<div class="flex-1 flex flex-col overflow-hidden">
  <!-- Main Content Area -->
  <div class="flex-1 overflow-auto p-6">
    <!-- Header Section -->
    <div class="header-container">
      <!-- Title Section -->
      <div class="title-section">
        <button (click)="onBack()" class="back-button">
          <i class="pi pi-arrow-left text-gray-600 text-sm"></i>
          <h1 class="document-title">{{ documentName }}</h1>
          <!-- Status for mobile and tablet -->
          <div class="status-indicator mobile-status">
            <!-- <div class="w-2 h-2 bg-orange-500 rounded-full"></div> -->
            <span class="status-badge"> {{ getStatusDisplayText() }} </span>
          </div>
        </button>

        <!-- Status for desktop -->
        <div class="status-indicator desktop-status">
          <div class="w-2 h-2 rounded-full" [class]="getStatusDotClass()"></div>
          <span class="status-badge"> {{ getStatusDisplayText() }} </span>
        </div>

        <!-- Buttons for mobile and tablet (inside title section) -->
        <div class="buttons-section mobile-buttons">
          @if (isManager) {
          <!-- Manager buttons: Comment and Review -->
          <div class="button-group">
            <p-button
              class="buttons-details"
              [label]="isMobile ? '' : 'Comment'"
              icon="pi pi-comment"
              (onClick)="onComment()"
            ></p-button>

            @if (!showReviewButtons) {
            <p-button
              class="buttons-details"
              [label]="isMobile ? '' : 'Review'"
              icon="pi pi-eye"
              (onClick)="onReview()"
            ></p-button>
            }

            <!-- Review buttons: Approve and Reject (shown after Review is clicked) -->
            @if (showReviewButtons) {
            <p-button
              class="button-approve"
              [label]="isMobile ? '' : 'Approve'"
              icon="pi pi-check"
              (onClick)="onApprove()"
            ></p-button>

            <p-button
              class="button-reject"
              [label]="isMobile ? '' : 'Reject'"
              icon="pi pi-times"
              (onClick)="onReject()"
            ></p-button>
            }
          </div>
          } @else {
          <!-- Non-manager buttons: View Audit Log, Edit, Archive -->
          <div class="button-group">
            <p-button
              class="buttons-details"
              [label]="isMobile ? '' : 'View Audit Log'"
              icon="pi pi-list"
              (onClick)="onViewAuditsLog()"
            ></p-button>

            @if (approveRejectStatus !== 2 && !isArchived) {
            <p-button
              class="buttons-details"
              [label]="isMobile ? '' : 'Edit'"
              icon="pi pi-pencil"
              (onClick)="onEdit()"
            ></p-button>
            }

            @if (approveRejectStatus !== 2 && !isArchived) {
            <p-button
              class="buttons-details"
              [label]="isMobile ? '' : 'Archive'"
              icon="pi pi-trash"
              (onClick)="onDelete()"
            ></p-button>
            }
          </div>
          }
        </div>
      </div>

      <!-- Buttons Section for desktop -->
      <div class="buttons-section desktop-buttons">
        @if (isManager) {
        <!-- Manager buttons: Comment and Review -->
        <div class="button-group">
          <p-button
            class="buttons-details"
            label="Comment"
            icon="pi pi-comment"
            (onClick)="onComment()"
          ></p-button>

          @if (!showReviewButtons) {
          <p-button
            class="buttons-details"
            label="Review"
            icon="pi pi-eye"
            (onClick)="onReview()"
          ></p-button>
          }

          <!-- Review buttons: Approve and Reject (shown after Review is clicked) -->
          @if (showReviewButtons) {
          <p-button
            class="button-approve"
            label="Approve"
            icon="pi pi-check"
            (onClick)="onApprove()"
          ></p-button>

          <p-button
            class="button-reject"
            label="Reject"
            icon="pi pi-times"
            (onClick)="onReject()"
          ></p-button>
          }
        </div>
        } @else {
        <!-- Non-manager buttons: View Audit Log, Edit, Archive -->
        <div class="button-group">
          <p-button
            class="buttons-details"
            label="View Audit Log"
            icon="pi pi-list"
            (onClick)="onViewAuditsLog()"
          ></p-button>

          @if (approveRejectStatus !== 2 && !isArchived) {
          <p-button
            class="buttons-details"
            label="Edit"
            icon="pi pi-pencil"
            (onClick)="onEdit()"
          ></p-button>
          }

          @if (approveRejectStatus !== 2 && !isArchived) {
          <p-button
            class="buttons-details"
            label="Archive"
            icon="pi pi-trash"
            (onClick)="onDelete()"
          ></p-button>
          }
        </div>
        }
      </div>
    </div>
    <div>
      <app-audit-modal
        [(visible)]="auditDialogVisible"
        [logs]="auditData"
        [row]="selectedRow"
        (close)="onAuditClose()"
      ></app-audit-modal>
    </div>

    <!-- Content Grid -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-6">
      <!-- Assigned Users Section -->
      <div class="lg:col-span-2">
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 class="text-lg font-semibold text-gray-800 mb-4">
            Assigned Users:
          </h2>

          @if (assignedUsersLoading) {
          <!-- Loading State -->
          <div class="flex items-center justify-center min-h-[200px]">
            <app-loader
              type="inline"
              message="Loading assigned users..."
              size="medium"
              ariaLabel="Loading assigned users"
            >
            </app-loader>
          </div>
          } @else {
          <div class="space-y-4">
            @if (assignedUsers && assignedUsers.length > 0) { @for (user of
            assignedUsers; track user.userId) {
            <div class="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg">
              <div class="flex-shrink-0">
                <div
                  class="w-10 h-10 bg-orange-500 rounded-full flex items-center justify-center text-white font-semibold"
                >
                  {{ getUserInitials(user.fullName) }}
                </div>
              </div>
              <div class="flex-1">
                <div class="flex items-center space-x-2 mb-2">
                  <h3 class="font-medium text-gray-800">{{ user.fullName }}</h3>
                  <div class="flex items-center space-x-1">
                    <div
                      class="w-2 h-2 rounded-full"
                      [class]="getStatusColor(user.status || 'pending')"
                    ></div>
                    <span
                      class="text-sm font-medium"
                      [class]="getStatusTextColor(user.status || 'pending')"
                    >
                      {{ getStatusDisplayName(user.status || "pending") }}
                    </span>
                  </div>
                </div>
                <!-- <p class="text-gray-600 text-sm mb-2">No Comments</p>
                <p class="text-gray-500 text-xs">No Date</p> -->
              </div>
            </div>
            } } @else {
            <div class="text-center py-8 text-gray-500">
              <p>No assigned users found</p>
            </div>
            }
          </div>
          }
        </div>
      </div>

      <!-- Document Info Card -->
      <div class="lg:col-span-1">
        <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
          <h2 class="text-lg font-semibold text-gray-800 mb-4">
            Document Information
          </h2>

          <!-- Document Details -->
          @if (documentInfoLoading) {
          <!-- Loading State -->
          <div class="flex items-center justify-center min-h-[200px]">
            <app-loader
              type="inline"
              message="Loading document information..."
              size="medium"
              ariaLabel="Loading document information"
            >
            </app-loader>
          </div>
          } @else {
          <div class="bg-white rounded-xl space-y-4">
            <!-- Dates -->
            <div class="grid grid-cols-3 text-center gap-3">
              <div>
                <p class="text-sm text-gray-600">Upload Date</p>
                <p class="font-semibold text-gray-900">
                  {{ documentInfo.uploadDate }}
                </p>
              </div>
              <div>
                <p class="text-sm text-gray-600">Assigned Date</p>
                <p class="font-semibold text-gray-900">
                  {{ documentInfo.assignedDate }}
                </p>
              </div>
              <div>
                <p class="text-sm text-gray-600">Due Date</p>
                <p class="font-semibold text-gray-900">
                  {{ documentInfo.dueDate }}
                </p>
              </div>
            </div>

            <!-- Document Viewer Section -->
            <!-- <div class="bg-blue-900 rounded-lg p-4">
              <div class="flex justify-between items-center">
                <div>
                  <span class="text-white text-sm">Document Name</span>
                  <p class="text-white font-medium">
                    {{ documentInfo.documentName }}
                  </p>
                </div>
                <button
                  (click)="onViewDocument()"
                  class="text-red-400 hover:text-red-300 text-sm font-medium transition-colors duration-200"
                >
                  View Document
                </button>
              </div>
            </div> -->
            <div
              class="text-white rounded-lg px-3 py-5 flex flex-col"
              [style.background-color]="'var(--color-background-document)'"
            >
              <!-- Row 1 -->
              <div class="text-xs pb-2">Document Name</div>

              <!-- Row 2 -->
              <div class="flex items-baseline justify-between">
                <div class="font-semibold">
                  {{ documentInfo.documentName }}
                </div>

                <button
                  type="button"
                  (click)="onViewDocument()"
                  class="text-[13px] font-semibold underline"
                  style="
                    color: var(--color-primary-red);
                    background: none;
                    border: none;
                    padding: 0;
                    cursor: pointer;
                    appearance: none;
                  "
                >
                  View Document
                </button>
              </div>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>

  <!-- Archive Confirmation Modal -->
  <app-modal
    [(visible)]="showDeleteModal"
    modalType="confirm"
    title="Archive Letter"
    message="Are you sure you want to archive this letter? This action cannot be undone."
    [confirmButtonText]="isDeleting ? 'Archiving...' : 'Confirm'"
    [confirmButtonDisabled]="isDeleting"
    cancelButtonText="Cancel"
    width="400px"
    (confirm)="confirmDeleteLetter()"
    (close)="cancelDeleteLetter()"
  ></app-modal>

  <!-- Document Viewer Modal -->
  <app-document-viewer-modal
    [(visible)]="showDocumentViewer"
    [attachment]="currentDocument"
    [loading]="!currentDocument"
    (download)="onDocumentDownload($event)"
    (openInNewTab)="onDocumentOpenInNewTab($event)"
    (close)="onDocumentViewerClose()"
  ></app-document-viewer-modal>

  <!-- Toast Messages -->
  <p-toast position="top-right"></p-toast>
</div>
